import React from "react";
import Icon from "@mdi/react";
import { mdiMapMarkerOutline, mdiPhoneOutline, mdiEmailOutline, mdiClockOutline, mdiWhatsapp } from "@mdi/js";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import MapEmbed from "../components/MapEmbed";
import { useSite } from "../theme/ThemeProvider";

const Contact = () => {
  const site = useSite();
  return (
    <Layout>
      <Seo
        title="İletişim ve Randevu"
        description={`${site.name} iletişim: ${site.address.line1}, ${site.address.line2}. Telefon ${site.phone}. Randevu ve teklif için formu doldurun.`}
        path="/iletisim"
      />
      <PageHero
        title="İletişim"
        text="Formu doldurun, aynı gün dönüş yapalım. Acil durumlarda arayın ya da WhatsApp'tan yazın."
        crumbs={[{ label: "İletişim" }]}
      />
      <section className="section">
        <div className="container">
          <div className="contact">
            <div className="card card__body">
              <h2 style={{ fontSize: "1.4rem" }}>Randevu / teklif formu</h2>
              <p className="muted">Yıldızlı alanlar zorunludur. Mesajınız {site.email} adresine iletilir.</p>
              <ContactForm />
            </div>
            <div className="contact__info">
              <div className="card info-card">
                <span className="icon-box"><Icon path={mdiMapMarkerOutline} /></span>
                <div>
                  <h4>Adres</h4>
                  <p>{site.address.line1}<br />{site.address.line2}</p>
                </div>
              </div>
              <div className="card info-card">
                <span className="icon-box"><Icon path={mdiPhoneOutline} /></span>
                <div>
                  <h4>Telefon</h4>
                  <a href={`tel:${site.phoneHref}`}>{site.phone}</a>
                </div>
              </div>
              <div className="card info-card">
                <span className="icon-box"><Icon path={mdiWhatsapp} /></span>
                <div>
                  <h4>WhatsApp</h4>
                  <a href={`https://wa.me/${site.whatsapp}`} target="_blank" rel="noreferrer">Mesaj gönderin</a>
                </div>
              </div>
              <div className="card info-card">
                <span className="icon-box"><Icon path={mdiEmailOutline} /></span>
                <div>
                  <h4>E-posta</h4>
                  <a href={`mailto:${site.email}`}>{site.email}</a>
                </div>
              </div>
              <div className="card info-card">
                <span className="icon-box"><Icon path={mdiClockOutline} /></span>
                <div>
                  <h4>Çalışma saatleri</h4>
                  {site.hours.map((h) => (
                    <p key={h.days}>{h.days}: {h.time}</p>
                  ))}
                </div>
              </div>
              <MapEmbed />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
